import { LanguageFilter, LanguageService, Component, TenantService, BaseTLDetailComponent, AxiosResponse, tlISODateTimeToLocalNoSecondsString, tlDateToISOString, RightHelper, ModulePartFilter, ModulePartService, TenantLanguageService, TenantLanguageFilter } from "../../../Infrastructure/CorBase/CoreBase";

interface iTenantLanguage {
	idTenant: number;
	idLanguages: number;
	languageName: string;
	languageIso: string;
	shortName: string;
	name: string;
	description: string;
};
	
	export default class TenantDetailBase extends BaseTLDetailComponent {

		returnRoute: string = "TenantList";
		tenantService: TenantService = new TenantService();
		modulePartService: ModulePartService = new ModulePartService();
		tenantLanguageService: TenantLanguageService = new TenantLanguageService();
		languageService: LanguageService = new LanguageService();

		modulAll: any[] = [];
		modulOld: any[] = [];
		modulModal: any[] = [];

		tenantLanguageAll: any[] = [];
		tenantLanguageOld: any[] = [];
		languageModal: any[] = [];

		protected selectItems: any[] = []; //vyber vice prvku	
		protected selectItemsLanguageTenant: any[] = []; //vyber vice prvku	

		formData = {
			id: 0,
			identifier: '',
			shortName: '',
			name: '',
			description: '',
			creationDate: '',
			idState: 0,
			idStateText: '',
			creationDateOrigin: '',
			isDeleted: false,
			isLock: false,
			languages: [] as any[],
			moduleParts: [] as any[],
			email: '',
			password: '',
			password2: '',
			isRegistration: false
		}; 
	

		async lockTenantBase() {
			this.processResponseLock(await this.tenantService.updateTenantLock(this.objectId, true));
		}

		async unlockTenantBase() {
			this.processResponseLock(await this.tenantService.updateTenantLock(this.objectId, false));
		}


		///hlaska o prekroceni inputu po Ctrl+V
		protected infoShortInputBase(maxLength: string): void {
			this.showAlertModalWithTitleAndContent(this.$t('global.messageInfo').toString(), this.$t('global.messageShortInput').toString() + maxLength + this.$t('global.messageShortInput2').toString());
		}

		protected fetchDataFromServer(): Promise<AxiosResponse<any>> {
			return this.tenantService.getById(this.objectId);
		}

		protected fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
			return super.NoCall()
		}

		protected refreshItems(items: any, refreshData: any): any {
			return items;
		}

		protected processResponse(response: AxiosResponse<any>): void {
			this.formData.id = response.data.id;
			this.formData.name = response.data.name;
			this.formData.shortName = response.data.shortName;
			this.formData.identifier = response.data.identifier;
			this.formData.description = response.data.description;
			this.formData.idState = response.data.idState;
			this.formData.idStateText = response.data.idStateText;
			this.formData.creationDateOrigin = response.data.creationDate;
			this.formData.creationDate = tlISODateTimeToLocalNoSecondsString(response.data.creationDate);
			this.formData.isDeleted = response.data.isDeleted;
			this.formData.isLock = response.data.isLock;
			this.formData.isRegistration = response.data.isRegistration;
			this.loadModulTenant();
			this.loadTenantLanguage();
		}

		protected processResponseLock(response: AxiosResponse<any>): void {
			if ( response.data.errorMessage != '') {
				this.showErrorMessage(response.data.errorMessage);
			}
			else {
				this.formData.idStateText = response.data.idStateText;
				this.formData.isLock = response.data.isLock;
			}
		}



		doAction() {

			if (this.tenantLanguageAll.length == 0) {
				this.showAlertModalWithTitleAndContent(this.$t('taskDetail.errorSave').toString(), this.$t('tenant.errorMessageLangOne').toString()); 

			}
			else {
				if (!this.styleFormNew) {
					if (!this.moduleNotChangeBase()) {
						this.saveChangeModulBase();
					}

					if (!this.languageTenantNotChangeBase()) {
						this.saveChangeLanguageTenantBase();
					}
				}
				else {
					this.formData.moduleParts = this.modulAll;
					this.formData.languages = this.tenantLanguageAll;
				}
				if (this.formIsInEditMode || this.styleFormDelete) {
					super.doCRUDActionWithInfoMessage(this.$t('tenant.messageNew').toString(), this.$t('tenant.messageEdit').toString(), this.$t('tenant.messageDelete').toString());
				}
			}
		}

		protected afterCreate(response: AxiosResponse<any>): void {
			this.formData.id = response.data.id;
			this.formData.creationDate = tlISODateTimeToLocalNoSecondsString(response.data.creationDate);


		}

		protected updateObject(): Promise<AxiosResponse<any>> {
			this.formData.creationDate = this.formData.creationDateOrigin;
			return this.tenantService.update(this.objectId, this.formData)
		}

		//old pryc
		//protected createObject(): Promise<AxiosResponse<any>> {		
		//	this.formData.creationDate = tlDateToISOString(new Date());
		//	this.formData.creationDateOrigin = tlDateToISOString(new Date());
		//	return this.tenantService.create(this.formData);
		//}

		protected createTenant() {
			this.formData.creationDate = tlDateToISOString(new Date());
			this.formData.creationDateOrigin = tlDateToISOString(new Date());
			this.tenantService.create(this.formData).then(res => {

				if (res.data.isSuccess == true) {
						this.processResponse(res);
					this.formIsInEditMode = false;
					this.styleFormNew = false;
					this.styleFormDetail = true;
					super.afterCreateChangeUrl(res.data.id);
				}
				else {
					this.showAlertModalWithErrorMessage(res.data.errorMessage);
				}
			});
		}

		protected deleteObject(): Promise<AxiosResponse<any>> {
			return this.tenantService.delete(this.objectId);
		}

		protected deleteBase() {
			return this.tenantService.delete(this.objectId).then(res => {
				this.goBack();
			});
		}

		vIsCorrectIdentif: boolean = true;
		vIsCorrectShotname: boolean = true;
		vIsCorrectName: boolean = true;
		vIsCorrectState: boolean = true;
		vEmail: boolean = true;
		vPassword: boolean = true;
		vPasswordAgain: boolean = true;

		validate() {
			var result = !(this.vIsCorrectIdentif && this.vIsCorrectShotname && this.vIsCorrectName && this.vEmail && this.vPassword && this.vPasswordAgain);
			return result;
		}

		isCorrectPassBase(value: any) {
			this.vPassword = value;// || !this.authPassword;
		}
		isCorrectPassAgainBase(value: any) {
			this.vPasswordAgain = value;// || !this.authPassword;
		}

		isCorrectEmailBase(value: any) {
			this.vEmail = value;
			//this.vEmail = value == false || this.formData.email == "";
		}

		isCorrectIdentifBase(value: any) {
			this.vIsCorrectIdentif = value;
		}
		isCorrectShotnameBase(value: any) {
			this.vIsCorrectShotname = value;
		}
		isCorrectNameBase(value: any) {
			this.vIsCorrectName = value;
		}
		isCorrectStateBase(value: any) {
			this.vIsCorrectState = value;
		}


		fieldsModul = [
			//	{ key: 'idRight', label: 'id', sortable: true, sortDirection: 'asc', class: 'text-center' },
			//{ key: 'identifier', label: this.$t('role.filterIdentif'), trans: 'role.filterIdentif', sortDirection: 'asc', sortable: true, class: 'text-center' },
			{ key: 'groupname', label: this.$t('tenant.modulGroup'), trans: 'tenant.modulGroup', sortable: true, class: 'text-left', thClass: 'firstColumnMichael' },
			{ key: 'name', label: this.$t('tenant.modulName'), trans: 'tenant.modulName', sortable: true, class: 'text-center' },
			{ key: 'description', label: this.$t('role.filterDescription'), trans: 'role.filterDescription', sortDirection: 'asc', sortable: true, class: 'text-center' },
			{ key: 'actions', label: '', class: 'text-right' }
		];

		fieldsModulModal = [
			//{ key: 'identifier', label: this.$t('role.fieldIdentif'), trans: 'role.fieldIdentif', sortable: true, class: 'text-center' },
			{ key: 'groupname', label: this.$t('tenant.modulGroup'), trans: 'tenant.modulGroup', sortable: true, class: 'text-left' },
			{ key: 'name', label: this.$t('tenant.modulName'), trans: 'tenant.modulName', sortable: true, class: 'text-center' },
			{ key: 'description', label: this.$t('role.fieldDescription'), trans: 'role.fieldDescription', sortable: true, class: 'text-center' },
		];

		filtersModulModal = [
			{ key: 'groupname', label: this.$t('tenant.modulGroup'), trans: 'tenant.modulGroup', selected: false, value: null, type: 'text' },
			{ key: 'name', label: this.$t('tenant.modulName'), trans: 'tenant.modulName', selected: true, value: null, type: 'text', isEditable: true, showOnlyClean: true },
			{ key: 'description', label: this.$t('role.filterDescription'), trans: 'role.filterDescription', selected: false, value: null, type: 'text' }
		];

		fieldsTenantLanguage = [
			{ key: 'languageName', label: this.$t('tenant.languageFieldName'), trans: 'tenant.languageFieldName', sortable: true, class: 'text-left', thClass: 'firstColumnMichael' },
			{ key: 'languageIso', label: this.$t('tenant.languageFieldIso'), trans: 'tenant.languageFieldIso', sortDirection: 'asc', sortable: true, class: 'text-center' },
			{ key: 'actions', label: '', class: 'text-right' }
		];

		fieldsTenantLanguageModal = [
			{ key: 'name', label: this.$t('tenant.languageFieldName'), trans: 'tenant.languageFieldName', sortable: true, class: 'text-left' },
			{ key: 'iso6392', label: this.$t('tenant.languageFieldIso'), trans: 'tenant.languageFieldIso', sortDirection: 'asc', sortable: true, class: 'text-center' }
		];

		filtersTenantLanguageModal = [
		
			{ key: 'name', label: this.$t('tenant.languageFieldName'), trans: 'tenant.languageFieldName', selected: true, value: null, type: 'text', isEditable: true, showOnlyClean: true },
			{ key: 'iso6392', label: this.$t('tenant.languageFieldIso'), trans: 'tenant.languageFieldIso', selected: false, value: null, type: 'text' }
		];


		protected initAllModul() {
			//pro modal dialog
			//this.isBusy = true;
			let filter: ModulePartFilter = new ModulePartFilter(null,null,true);
			
			this.modulePartService.getAllByFilter(filter).then(res => {
				var result = [];
				for (var i = 0; i < res.data.length; i++) {
					this.modulModal = [];
					if (this.modulAll.filter(c => c.id == res.data[i].id).length == 0) {
						result.push(res.data[i]);
					}
				}
			//	this.isBusy = false;
				this.modulModal = result;
			});
		}

		protected loadLanguage() {
			//pro modal dialog
		//	this.isBusy = true;
			let filter: LanguageFilter = new LanguageFilter(true);
			this.languageService.getAllByFilter(filter).then(res => {
				this.languageModal = [];
				(res.data as Array<any>).forEach(item => {
					if (!this.tenantLanguageAll.some(c => c.idLanguages == item.id)) {
						this.languageModal.push(item);
					}
				});
				
				//this.tenantLanguageAll.forEach(val => this.tenantLanguageOld.push(Object.assign({}, val)));
				this.isBusy = false;
			});
		}

		protected loadTenantLanguage() {
			//pro modal dialog
			this.isBusy = true;
			let filter: TenantLanguageFilter = new TenantLanguageFilter(this.formData.id);
			this.tenantLanguageService.getAllByFilter(filter).then(res => {
				this.tenantLanguageAll = res.data;
				this.tenantLanguageOld = [];
				this.tenantLanguageAll.forEach(val => this.tenantLanguageOld.push(Object.assign({}, val)));
				this.isBusy = false;
			}).catch(error => {
				this.showAlertModalWithErrorMessage(this.$t('errorsall.errorMessageLoadLanguageTenant').toString());
				this.isBusy = false;
			});
		}


		goBackLanguageTenantBase() {
			this.tenantLanguageAll = [];
			this.tenantLanguageOld.forEach(val => this.tenantLanguageAll.push(Object.assign({}, val)));
		}

		saveChangeLanguageTenantBase() {
			this.tenantLanguageService.updateTenantLanguage(this.formData.id, this.tenantLanguageAll).then(res => {
				this.tenantLanguageAll = res.data;
				this.tenantLanguageOld = [];
				this.tenantLanguageAll.forEach(val => this.tenantLanguageOld.push(Object.assign({}, val)));
			});
		}

		deleteLanguageTenantBase(item: any) {
			this.tenantLanguageAll = this.tenantLanguageAll.filter((c: any) => c.idLanguages != item.idLanguages);
		}

		addNewLanguageTenantBase() {
			this.loadLanguage();
			this.$bvModal.show('tenantLanguageModal');
		}

		
		selectedLanguageTenantItemsBase(items: any) {
			for (var i = 0; i < items.length; i++) {
				var item = this.languageModal.filter(c => c.id == items[i])[0];
				
				let addTenantLangItem: iTenantLanguage = {
					languageName: item.name,
					idLanguages: item.id,
					idTenant: this.formData.id,
					name: item.name,
					description: '',
					languageIso: item.iso6392,
					shortName:''
					// inicializace dalších vlastností...
				};
				this.tenantLanguageAll.push(addTenantLangItem);
			}
		}

		selectRowsLanguageTenant(items: any) {
			this.selectItemsLanguageTenant = [];
			for (var i = 0; i < items.length; i++) {
				this.selectItemsLanguageTenant.push(items[i]);
			}
		}

		public languageTenantNotChangeBase(): boolean {
			if (this.tenantLanguageAll.length != this.tenantLanguageOld.length) {
				return false;
			}
			else {
				for (var i = 0; i < this.tenantLanguageAll.length; i++) {
					if (!this.tenantLanguageOld.some(c => c.idLanguages == this.tenantLanguageAll[i].idLanguages)) {
						return false;
					}
				}
			}
			return true;
		}

		protected loadModulTenant() {
			//pro modal dialog
			this.isBusy = true;
			let filter: ModulePartFilter = new ModulePartFilter(this.formData.id, null, null);
			this.modulePartService.getAllByFilter(filter).then(res => {
				this.modulOld = [];
				this.modulAll = res.data;
				this.modulAll.forEach(val => this.modulOld.push(Object.assign({}, val)));
				this.isBusy = false;				
			}).catch(error => {
				this.showAlertModalWithErrorMessage(this.$t('errorsall.errorMessageLoadModulTenant').toString());
				this.isBusy = false;
			});
		}

		goBackModulBase() {
			this.modulAll = [];
			this.modulOld.forEach(val => this.modulAll.push(Object.assign({}, val)));
		}

		saveChangeModulBase() {
			this.modulePartService.updateModulePartTenant(this.formData.id, this.modulAll).then(res => {
				this.modulAll = res.data;
				this.modulOld = [];
				this.modulAll.forEach(val => this.modulOld.push(Object.assign({}, val)));
			});
		}

		deleteModulBase(item:any) {
			this.modulAll = this.modulAll.filter((c: any) => c.id != item);
		}

		addNewModulBase() {
			this.initAllModul();
			this.$bvModal.show('modulModal');
		}

		selectedModulItemsBase(items: any) {
			for (var i = 0; i < items.length; i++) {
				var item = this.modulModal.filter(c => c.id == items[i])[0];
				this.modulAll.push(item);
			}
		}

		selectRows(items: any) {
			this.selectItems = [];
			for (var i = 0; i < items.length; i++) {
				this.selectItems.push(items[i]);
			}
		}

		public moduleNotChangeBase(): boolean {
			if (this.modulAll.length != this.modulOld.length) {
				return false;
			}
			else {
				for (var i = 0; i < this.modulAll.length; i++) {
					if (this.modulOld.filter(c => c.id == this.modulAll[i].id).length == 0) {
						return false;
					}
				}
			}
			return true;
		}

		protected get showSaveAllBase(): boolean {
			return !this.moduleNotChangeBase() || !this.languageTenantNotChangeBase();
		}

		protected get showEditButtonChild(): boolean {
			return this.showEditButton && ( RightHelper.currentUserIsSuperUser());
		}
		protected get showEditButtonChildSub(): boolean {
			return ( RightHelper.currentUserIsSuperUser());
		}

		protected  resendEmailRegistrationBase() {
			this.tenantService.resendRegistration(this.formData.id, this.formData).then(res => {
				if (res.data.isSuccess == false) {
					this.showAlertModalWithErrorMessage(res.data.errorMessage);
				}
				else {
					this.showAlertModalWithInfoMessage(this.$t('tenant.infoSendRegistrationTenant').toString());
				}
			});
		}

		protected confirmRegistrationTenantBase() {
			this.tenantService.confirmRegistrationTenant(this.formData.id, this.formData).then(res => {
				if (res.data.isSuccess == false) {
					this.showAlertModalWithErrorMessage(res.data.errorMessage);
				}
				else {
					this.processResponse(res);
					this.showAlertModalWithInfoMessage(this.$t('tenant.infoConfirmTenant').toString());
				}
			});
		}

	}

